import {Transition, type TransitionProps} from '@mantine/core';
import {BasicButton} from '@packages/ui';
import {CommonLink} from '../../../../../shared/components/CommonLink';
import {appendQueryParam} from '../../../../../shared/services/appendQueryParam';

type Props = Omit<TransitionProps, 'children'> & {
  entryURL: string;
  sourceUrl?: string;
  className?: string;
  buttonClassName?: string;
};

export const TransitionEntryButton: React.FC<Props> = ({
  entryURL,
  sourceUrl,
  className,
  buttonClassName,
  ...transitionProps
}: Props) => {
  const href = sourceUrl
    ? appendQueryParam(entryURL, 'source_url', sourceUrl)
    : entryURL;

  return (
    <Transition {...transitionProps}>
      {(styles) => (
        <div className={className} style={styles}>
          <div className="flex justify-center flex-wrap mb-16 pc:py-8 pc:mb-0">
            <CommonLink
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              id="recruiting_info_entry_button"
            >
              <BasicButton
                label="エントリー"
                className={buttonClassName}
                isPrimary={false}
                isLarge={false}
                isDisabled={false}
              />
            </CommonLink>
          </div>
        </div>
      )}
    </Transition>
  );
};
